import { all, call, fork, put, take } from "redux-saga/effects";
import { ClientBookmark } from "src/domain/model/client_bookmark";
import { Customer } from "src/domain/model/customer";
import { IClientBookmarkRepository } from "src/domain/repository/client_bookmark_repository";
import { ICustomerRepository } from "src/domain/repository/customer_repository";
import {
  IJobCareerRepository,
  TJobCareerWithCustomerID,
} from "src/domain/repository/job_career_repository";
import { IApiClient, createApiClient } from "src/infra/api/client";
import { createClientBookmarkAPI } from "src/infra/api/service/client_bookmark_api";
import { createCustomerAPI } from "src/infra/api/service/customer_api";
import { createJobCareerAPI } from "src/infra/api/service/job_career_api";
import {
  ClientPmCampaignActionType,
  IClientPmCampaignActionCreator,
  IRequestGetCustomerByClientPmCampaignPageAction,
  createClientPmCampaignActionCreator,
} from "../action/client_pm_campaign";
import { GetCustomersByClientPmCampaignPageResponse } from "../response/customer_response";
import { handleErrorForHandler } from "./handleErrorForHandler";

const apiClient: IApiClient = createApiClient();
const customerRepository: ICustomerRepository = createCustomerAPI(apiClient);
const jobcareerRepository: IJobCareerRepository = createJobCareerAPI(apiClient);
const clientBookmarkRepository: IClientBookmarkRepository =
  createClientBookmarkAPI(apiClient);
const actionCreater: IClientPmCampaignActionCreator =
  createClientPmCampaignActionCreator();

function* handleGetCustomersInPmCampaignPage() {
  while (true) {
    try {
      const action: IRequestGetCustomerByClientPmCampaignPageAction =
        yield take(ClientPmCampaignActionType.REQUEST_GET_CUSTOMERS);

      const [
        pmCustomers,
        toBPmCustomers,
        toCPmCustomers,
        bizdevPmCustomers,
        growthPmCustomers,
        pmmCustomers,
        poCustomers,
        clientBookmarks,
      ] = yield all([
        call(getCustomersByIDs, action.item.pmCustomerIDs),
        call(getCustomersByIDs, action.item.toBPmCustomerIDs),
        call(getCustomersByIDs, action.item.toCPmCustomerIDs),
        call(getCustomersByIDs, action.item.bizdevPmCustomerIDs),
        call(getCustomersByIDs, action.item.growthPmCustomerIDs),
        call(getCustomersByIDs, action.item.pmmCustomerIDs),
        call(getCustomersByIDs, action.item.poCustomerIDs),
        call(getAllClientBookmark),
      ]);

      let allCustomerList: Customer[] = [];
      allCustomerList = allCustomerList.concat(
        pmCustomers,
        toBPmCustomers,
        toCPmCustomers,
        bizdevPmCustomers,
        growthPmCustomers,
        pmmCustomers,
        poCustomers
      );
      const customerIdList: string[] = yield call(
        createCustomerIdList,
        allCustomerList
      );
      const jobCareersWithCustomerID: TJobCareerWithCustomerID[] = yield call(
        getJobcareerAllByCustomerIDs,
        customerIdList
      );
      const res: GetCustomersByClientPmCampaignPageResponse =
        new GetCustomersByClientPmCampaignPageResponse();
      res.pmCustomers = pmCustomers;
      res.toBPmCustomers = toBPmCustomers;
      res.toCPmCustomers = toCPmCustomers;
      res.bizdevPmCustomers = bizdevPmCustomers;
      res.growthPmCustomers = growthPmCustomers;
      res.pmmCustomers = pmmCustomers;
      res.poCustomers = poCustomers;
      res.jobCareersWithCustomerID = jobCareersWithCustomerID;
      res.clientBookmarks = clientBookmarks;

      yield put(
        actionCreater.callbackGetCustomerByClientPmCampaignPageAction(true, res)
      );
    } catch (error) {
      yield fork(handleErrorForHandler, error);
      yield put(
        actionCreater.callbackGetCustomerByClientPmCampaignPageAction(
          false,
          undefined
        )
      );
    }
  }
}

const createCustomerIdList = (customerList: Customer[]): string[] => {
  return customerList.map((item: Customer) => {
    return item.id;
  });
};

// 指定したID順・件数どおりにCustomerを組み立てる。
// getAllByIDsはサーバ側でID重複が解決されるため、開発環境のように同一IDを
// 複数並べたケースでも、リクエスト件数分のカードを表示できるようにする。
const getCustomersByIDs = (ids: string[]): Promise<Customer[]> => {
  return customerRepository.getAllByIDs(ids).then((customers: Customer[]) => {
    return ids
      .map((id: string) => customers.find((c: Customer) => c.id === id))
      .filter((c: Customer | undefined): c is Customer => c !== undefined);
  });
};

const getJobcareerAllByCustomerIDs = (
  ids: string[]
): Promise<TJobCareerWithCustomerID[]> => {
  return jobcareerRepository.getAllByCustomerIDsForScout(ids);
};

const getAllClientBookmark = (): Promise<ClientBookmark[]> => {
  return clientBookmarkRepository.getAllByClient();
};

export { handleGetCustomersInPmCampaignPage };



// WEBPACK FOOTER //
// ./src/presentation/handler/client_pm_campaign_handler.ts